export const USER_ANALYTICS = {
  "USERS: Add New": () => ({}),
  "USERS: Resend Invite": () => ({}),
  "USERS: Suspend": () => ({}),
};
